<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <div class="content-body" ref="viewBox">
      <!--活动内容主体-->
      <h2 style="margin-top: 40px; clear: both;">
        <span>填写报名信息</span>
      </h2>

      <div class="join_box_Xq first">
        <ul class="pop_massage only" data-index="0">
          <li class="dan_h" v-for="(item,index) in fields" :key="index">
            <div class="optionsName">
              <span style="color: #ee0a24;font-size:16px" v-if="item.is_empty==1">*</span>
              {{index+1}}. {{item.name}}
            </div>
            <div class="inpoutK">
              <template v-if="item.type=='单行文本'">
                <el-input v-model="itemData[item.item_name]" :placeholder="item.prompt"></el-input>
              </template>
              <template v-if="item.type=='多行文本'">
                <el-input
                  type="textarea"
                  :rows="4"
                  :placeholder="item.prompt"
                  v-model="itemData[item.item_name]"
                ></el-input>
              </template>
              <template v-if="item.type=='单项选择'">
                <el-radio-group v-model="itemData[item.item_name]">
                  <el-radio
                    border
                    :label="option.value"
                    v-for="(option,o) in item.option"
                    :key="o"
                  >{{option.value}}</el-radio>
                </el-radio-group>
              </template>
              <template v-if="item.type=='多项选择'">
                <el-checkbox-group v-model="itemData[item.item_name]">
                  <el-checkbox
                    border
                    v-for="option in item.option"
                    :label="option.value"
                    :key="option.value"
                  >{{option.value}}</el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-if="item.type=='下拉菜单'">
                <el-select
                  v-model="itemData[item.item_name]"
                  :placeholder="item.prompt"
                  style="width:100%"
                >
                  <el-option
                    v-for="option in item.option"
                    :key="option.value"
                    :label="option.value"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-if="item.type=='日期选择'">
                <el-date-picker
                  v-model="itemData[item.item_name]"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="item.prompt"
                ></el-date-picker>
              </template>
            </div>
          </li>
        </ul>
      </div>

      <div class="submit">
        <el-button type="primary" :disabled="disabled" @click="doLogin({success:sign})">{{signText}}</el-button>
      </div>
    </div>
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import "./custom.css";
import webHeader from "../Public/header";
import miniCrumb from "../Public/miniCrumb";
import recommendNews from "_c/recommend/news";
import recommendActivity from "_c/recommend/activity";
import recommendProject from "_c/recommend/project";
export default {
  components: {
    webHeader,
    miniCrumb,
    recommendNews,
    recommendActivity,
    recommendProject
  },
  data() {
    return {
      checkbox: [],
      ticketIndex: -1,
      signText: "提交报名",
      disabled: false,
      dialogTableVisible: true,
      hover: false,
      data: {},
      itemData: {},
      applyData: {},
      search: {
        type: null
      },
      fields: [],
      liData: ["liBg1", "liBg2", "liBg3"],
      applyInfo: {
        list: [],
        total: 0
      }
    };
  },
  methods: {
    ticketClick(index) {
      let number = this.data.ticket_list[index].number;
      if (number === 0) {
        this.$message({
          showClose: true,
          message: "报名人数已满",
          type: "warning"
        });
      } else {
        this.ticketIndex = index;
        this.applyData.ticket_id = this.data.ticket_list[index].id;
      }
    },
    test() {
      this.$router.push({ name: "userInfo" });
    },
    //活动报名
    sign(e) {
      let that = this;
      this.$db.get(this.$url.user.url).then(resp => {
        let data = resp.data;
        if (data) {
          if (this.data.type == 2) {
            //反哺活动，只能反哺大学生参与
            if (!data.is_college_student) {
              this.$notify({
                title: "提示信息",
                message: "该活动只允许反哺大学生参与",
                type: "warning"
              });
              return false;
            }
          }
          //如果是志愿者或者是反哺大学生  允许直接报名
          if (data.is_college_student || data.is_volunteer) {
            //判断是否需要提交表单
            this.disabled = true;
            this.signText = "正在提交报名";
            this.applyData.custom = this.itemData;
            this.$db
              .post(this.$url.activity.apply.url, this.applyData)
              .then(resp => {
                if (resp && resp.data) {
                  this.$message({
                    message: "报名成功",
                    type: "success",
                    duration: 1000,
                    onClose: function() {
                      that.$router.push({
                        name: "activityInfo",
                        query: {
                          id: that.activity_id
                        }
                      });
                    }
                  });
                } else {
                  this.disabled = false;
                  this.signText = "提交报名";
                }
              });
          } else {
            //登录过，但不是志愿者或者反哺大学生
            this.$confirm("您还不是志愿者，请先注册成为志愿者", "消息提示", {
              confirmButtonText: "立即前往注册",
              showCancelButton: false,
              type: "warning"
            })
              .then(() => {
                //跳转到志愿者注册页面
              })
              .catch(() => {});
          }
        }
      });
    },
    scrollBehavior() {
      document.getElementById("dt_list_main").scrollIntoView();
    },
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index / 3);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg2";
      }
    },
    handleScroll() {
      if (this.getScrollBottomHeight() <= -650) {
        this.hover = true;
      } else {
        this.hover = false;
      }
    },
    //滚动条到底部的距离
    getScrollBottomHeight() {
      return (
        this.getPageHeight() - this.getScrollTop() - this.getWindowHeight()
      );
    },
    //页面高度
    getPageHeight() {
      return document.querySelector("html").scrollHeight;
    },
    //滚动条顶 高度
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    init() {
      let id = this.$route.query.activity_id;
      let ticket_id = this.$route.query.ticket_id;
      this.applyData.ticket_id = ticket_id;
      this.activity_id = id;
      let that = this;
      this.$db
        .get(this.$url.activity.url + "/" + id)
        .then(resp => {
          const data = resp.data;
          this.data = data;
          this.applyData.activity_id = id;
          //活动时间未过、报名已截止
          if (data.activity_sign_up_status == 3 && data.activity_status != 3) {
            this.signText = "报名已截止";
            this.disabled = true;
          }
          //活动时间已过
          if (data.activity_status == 3) {
            this.signText = "活动已结束";
            this.disabled = true;
          }
        })
        .then(resp => {
          let params = {
            id
          };
          this.$db.post(this.$url.activity.checkApply, params).then(resp => {
            if (resp && resp.data.is_apply) {
              this.signText = "您已报名";
              this.disabled = true;
            }
          });
        })
        .then(resp => {
          //查询对应的表单信息
          let data = {
            activity_id: id
          };
          this.$db.post(this.$url.activity.custom.url, data).then(resp => {
            this.fields = resp.data;
            var obj = new Object();
            this.fields.forEach(element => {
              if (element.type == "多项选择") {
                obj[element.item_name] = [];
              }
            });
            this.itemData = obj;
            console.log(this.fields, "fil");
          });
        });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  //页面销毁，页面销毁时移除监听事件，否则其他页面也会自动进入scroll的监听中
  destroyed() {},
  watch: {
    $route(to, from) {
      this.$router.go(0);
      //this.init()
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/Activity/custom.vue